import type { VideoClock } from "../playback/videoClock";

export interface Timeline {
  setDuration(seconds: number): void;
  setCurrent(seconds: number): void;
}

/**
 * Wire the play/pause button + range scrubber + ts readout to the VideoClock.
 * Scrubbing seeks the video; play/pause toggle the same. The rAF loop calls
 * setCurrent() once per frame to keep the readout & slider live.
 */
export function setupTimeline(clock: VideoClock): Timeline {
  const playBtn = document.getElementById("play-pause") as HTMLButtonElement;
  const slider = document.getElementById("timeline") as HTMLInputElement;
  const readout = document.getElementById("ts-readout") as HTMLSpanElement;

  let duration = 0;
  let isUserDragging = false;

  playBtn.addEventListener("click", () => {
    if (clock.paused) {
      void clock.play();
      playBtn.textContent = "pause";
    } else {
      clock.pause();
      playBtn.textContent = "play";
    }
  });

  slider.addEventListener("input", () => {
    isUserDragging = true;
    const t = Number(slider.value) * duration;
    clock.seek(t);
  });
  slider.addEventListener("change", () => {
    isUserDragging = false;
  });

  // Reflect external play/pause (e.g. video reaches end).
  clock.el.addEventListener("play",  () => playBtn.textContent = "pause");
  clock.el.addEventListener("pause", () => playBtn.textContent = "play");

  return {
    setDuration(seconds: number) {
      duration = seconds;
    },
    setCurrent(seconds: number) {
      if (!isUserDragging && duration > 0) {
        slider.value = String(seconds / duration);
      }
      readout.textContent = `${seconds.toFixed(2)} / ${duration.toFixed(2)}`;
    },
  };
}
